import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type ConfirmChangeSeverity = 'destructive' | 'project' | 'info';

export interface ConfirmChangeDialogData {
  title: string;
  message: string;
  severity: ConfirmChangeSeverity;
}

@Component({
  selector: 'app-confirm-change-dialog',
  templateUrl: './confirm-change-dialog.component.html',
  styleUrls: ['./confirm-change-dialog.component.scss'],
  standalone: false,
})
export class ConfirmChangeDialogComponent {
  understood = false;

  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ConfirmChangeDialogData,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onProceed(): void {
    if (this.understood) {
      this.dialogRef.close(true);
    }
  }
}
